import { render, staticRenderFns } from "./create-or-edit-rule.vue?vue&type=template&id=14b6e2cb"
import script from "./create-or-edit-rule.ts?vue&type=script&lang=js&external"
export * from "./create-or-edit-rule.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports